import React from 'react';
import Home from './gui/home'
import { currentRoute, onRouteChange } from './lib/router';

// Der Admin-Bereich wird erst beim Aufruf von /admin nachgeladen. Dadurch
// bleiben firebase/auth und firebase/storage aus dem Bundle der öffentlichen
// Seite heraus.
const Admin = React.lazy(() => import('./gui/admin'));

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      route: currentRoute()
    };
  }

  componentDidMount() {
    this.disposeRoute = onRouteChange(() => {
      this.setState({ route: currentRoute() });
    });
  }

  componentWillUnmount() {
    if (this.disposeRoute) {
      this.disposeRoute();
    }
  }

  render() {
    if (this.state.route === 'admin') {
      return (
        <React.Suspense fallback={<div className="admin-note">Einen Moment &hellip;</div>}>
          <Admin />
        </React.Suspense>
      );
    }

    return (<div>
      <div class='hidden' id="googleinfo">Augenstern Schmuck: Ringe, Ketten by Alexandra Gabriele Faltermeier </div>
      <Home />
    </div >
    );
  }
}

export default App;
